export default __webpack_public_path__ + "static/speaker_bg-be8e941a187cdc77d2414e351dfec03b.png";